import { Location } from '@angular/common';
import { Component, Input } from "@angular/core";
import { Router } from '@angular/router';


@Component({
  selector: 'app-btn-back',
  templateUrl: './btn-back.component.html',
  styleUrls: ['./btn-back.component.scss'],
  standalone: true,
})

export class ButtonBackComponent  {
  constructor(
    private location: Location,
    private router: Router) {
  }

  @Input() backLocation?: string;


  goBack(): void {
    if (this.backLocation)
      this.router.navigate([this.backLocation]);
    else
      this.location.back();


  }

}
